<template>
  <step-block
    class="step-block--window-type"
    v-bind="$attrs"
    v-on="$listeners"
    :title="name"
  >
    <figure slot="cover">
      <img
        class="img-fluid"
        v-if="photo"
        :src="photo"
      >
    </figure>
  </step-block>
</template>

<script>
  export default {
    name: 'WindowTypeBlock',
    props: {
      id: [String, Number],
      name: String,
      photo: String,
    },
  };
</script>
